import { doc, deleteDoc, getDoc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { db, storage } from "@root/firebase"; // Adjust to your Firebase configuration file

/**
 * Deletes a file from Firestore and Cloud Storage.
 * @param {string} firestorePath - Path to the Firestore document.  i.e. "memorials/tributeId"
 * @param {string} imagePath - Path to the file in Cloud Storage. i.e. "images/memorials/tributeId/image.jpg"
 * @returns {Promise<void>}
 */
export const deleteFile = async (firestorePath, imagePath=false) => {
  try {
    // Step 1: Check if the Firestore document exists
    const docRef = doc(db, firestorePath);
    const docSnapshot = await getDoc(docRef);

    if (!docSnapshot.exists()) {
      console.warn(`Document at path "${firestorePath}" does not exist. Skipping deletion.`);
    } else {
      // Step 2: Remove the Firestore document
      await deleteDoc(docRef);
      console.log(`Document at path "${firestorePath}" deleted from Firestore.`);
    }

    // Step 3: Delete the file from Cloud Storage
    if (imagePath) {
      const storageRef = ref(storage, imagePath);
      await deleteObject(storageRef);
      console.log(`File at path "${imagePath}" deleted from Cloud Storage.`);
    }
    
  } catch (error) {
    console.error("Error deleting file:", error.message);
    throw error; // Propagate the error if needed
  }
};



export function createRandomString(length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
    let result = "";
    const randomArray = new Uint8Array(length);
    crypto.getRandomValues(randomArray);
    randomArray.forEach((number) => {
      result += chars[number % chars.length];
    });
    return result;
  }
